<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">QUICK PLAY</div>
    <div class="sopo-popup-text">Please select a game mode for your quickplay event.</div>
    <div class="game-selector-wrapper">
        <div class="game-selector clickable" [class.selected]="selectedGame === 'Ring'" (click)="selectGameType('Ring')">
            <img class="selector-img" src="/assets/img/lobby/quickplay-create.webp" alt="Quickplay Icon" />
            <div class="selector-text-container">
                <div class="title">RING</div>
            </div>
        </div>
        <div class="game-selector clickable" [class.selected]="selectedGame === 'SNG'" (click)="selectGameType('SNG')">
            <img class="selector-img" src="/assets/img/lobby/quickplay-create.webp" alt="Quickplay Icon" />
            <div class="selector-text-container">
                <div class="title">SNG</div>
            </div>
        </div>
        <div class="game-selector clickable" [class.selected]="selectedGame === 'MTT'" (click)="selectGameType('MTT')">
            <img class="selector-img" src="/assets/img/lobby/quickplay-create.webp" alt="Quickplay Icon" />
            <div class="selector-text-container">
                <div class="title">MTT</div>
            </div>
        </div>
    </div>
    <div class="sopo-popup-button-container">
        <span class="sopo-popup-red-button clickable" (click)="close()">CANCEL</span>
        <span class="sopo-popup-green-button clickable"(click)="createQuickplay()">CREATE</span>
    </div>
</div>
